import React, { useEffect, memo } from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';
import s from './Embed.scss';

const areEqual = (prevProps, { content }) => {
	if (prevProps?.content?.rawText === content?.rawText) return true;
	return false;
};

const Embed = ({ content = {} }) => {
	useEffect(() => {
		if ((content.rawText || '').indexOf('ot-sdk-cookie-policy') !== -1 && typeof window.OneTrust !== 'undefined') {
			window.OneTrust.LoadBanner();
		}

		return () => {
			[...document.head.querySelectorAll('.js-embedScripts')].map((node) => node && node.remove());
		};
	}, [content.rawText]);

	useEffect(() => {
		if ((content.rawText || '').indexOf('yotpo') !== -1 && typeof window.yotpo !== 'undefined') {
			window.yotpo.refreshWidgets();
		}
	});

	return (
		<div className={s.embed} dangerouslySetInnerHTML={{ __html: purifier(content.rawText, { ADD_TAGS: ['iframe', 'script'], KEEP_CONTENT: false }) }} />
	);
};

export default hot(module)(memo(Embed, areEqual));
